export * from './chips.component';
export * from './chips.module';



// WEBPACK FOOTER //
// ./src/app/typescripts/pro/tags/index.ts